export default (store) => {
  const ability = store.getters['auth/ability']

  ability.update(store.state.auth.rules)

  return store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'auth/CREATE_RULES':
        ability.update(mutation.payload)
        break
      case 'auth/DESTROY_RULES':
        ability.update([{ actions: 'read', subject: 'all' }])
        break
    }
  })
}
